import React from "react";
import { Svg, Path } from "../componet/NavBar/style";

function Icon({ modalFlag, URLCurrent }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 9 5"
      modalFlag={modalFlag}
    >
      <Path
        strokeLinecap="round"
        strokeWidth="0.685"
        d="M1.148.796l3.426 3.426L8 .796"
        URLCurrent={URLCurrent}
      ></Path>
    </Svg>
  );
}

export default Icon;
